import "./index.less";

import React from "react";
import { useSelector } from "react-redux";

import RecommendCard from "./comps/recommend-card";
import ViewsCard from "../../components/views-card";
import BarChart from "../../components/bar-chart";
import CardBox from "../../components/card-box";
import UserInfo from "@/pages/LsHome/comps/user-info";
import SysConf from "@/conf/sys.map.config";

import { TStoreData, TTrackingData, APP_PORTAL } from "@/interface";

interface TPvItem {
  menu?: string;
  type?: string;
  value?: number;
}

interface TUvItem {
  menu?: string;
  type?: string;
  value?: number;
}

const Home: React.FC = () => {
  const storeData = useSelector((data: TStoreData) => {
    return {
      trackingData: data?.eventTracking,
    };
  });
  const { trackingData } = storeData;
  const pvData: TPvItem[] = [];
  const uvData: TUvItem[] = [];
  const gridBd = [];
  const bdTotal = [];

  const formatData = (data: TTrackingData) => {
    const buryData = data?.menuBuryData || [];
    const gridData = data?.gridBdCount || [];
    const gridTotal = data?.totalBdCount || [];

    buryData.forEach((t) => {
      pvData.push(
        {
          menu: t.name,
          type: "昨日",
          value: t.PV,
        },
        {
          menu: t.name,
          type: "周",
          value: t.weekPV,
        },
        {
          menu: t.name,
          type: "月",
          value: t.monthPV,
        }
      );
    });
    buryData.forEach((t) => {
      uvData.push(
        {
          menu: t.name,
          type: "昨日",
          value: t.UV,
        },
        {
          menu: t.name,
          type: "周",
          value: t.weekUV,
        },
        {
          menu: t.name,
          type: "月",
          value: t.monthUV,
        }
      );
    });

    gridData.forEach((t) =>
      gridBd.push(
        {
          menu: t.name,
          type: "BD",
          value: t.BD,
        },
        {
          menu: t.name,
          type: "BDL",
          value: t.BDL,
        },
        {
          menu: t.name,
          type: "BDM",
          value: t.BDM,
        },
        {
          menu: t.name,
          type: "CM",
          value: t.CM,
        }
      )
    );

    gridTotal.forEach((t) =>
      bdTotal.push({
        menu: t.name,
        type: "总计",
        value: t.count,
      })
    );
  };

  formatData(trackingData);
  const CardComp = SysConf.BI.cardComp.default;
  return (
    <div className="jx-home">
      <div className="jx-home-middle-info">
        <div className="jx-home-card">
          <CardBox title={SysConf.BI.cardName}>
            <CardComp />
          </CardBox>
        </div>
        <div className="jx-home-card">
          <RecommendCard />
        </div>
        <div className="jx-home-card">
          <CardBox title={SysConf.BI.firstBIName}>
            <BarChart
              id="pvBarChartS"
              height={300}
              data={SysConf.name === APP_PORTAL.CRM ? gridBd : pvData}
            />
          </CardBox>
        </div>
        <div className="jx-home-card">
          <CardBox title={SysConf.BI.secBIName}>
            <BarChart
              id="uvBarChartS"
              height={300}
              data={SysConf.name === APP_PORTAL.CRM ? bdTotal : uvData}
            />
          </CardBox>
        </div>
      </div>
      <div className="jx-home-user-info">
        <UserInfo />
      </div>
    </div>
  );
};

export default Home;
